exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select {\r\n    width: 50% !important;\r\n}\r\n\r\n\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/views/dashboards/dashboard4.template.css
// module id = 987
// module chunks = 0